//QUERY
export const GET_QUERY_INITIALIZE = 'GET_QUERY_INITIALIZE'
export const GET_QUERY_DATA_ATTEMPT = 'GET_QUERY_DATA_ATTEMPT'
export const GET_QUERY_DATA_DATA_POOL_ATTEMPT = 'GET_QUERY_DATA_DATA_POOL_ATTEMPT'

export const GET_MULTIPLE_QUERY_DATA_ATTEMPT = 'GET_MULTIPLE_QUERY_DATA_ATTEMPT'
export const GET_MULTIPLE_QUERY_DATA_DATA_POOL_ATTEMPT = 'GET_MULTIPLE_QUERY_DATA_DATA_POOL_ATTEMPT'

export const GET_QUERY_OBJECT_RESULT = 'GET_QUERY_OBJECT_RESULT'
export const GET_QUERY_LIST_RESULT = 'GET_QUERY_LIST_RESULT'
export const GET_QUERY_ERROR = 'GET_QUERY_ERROR'
export const GET_BY_POST_OBJECT_ATTEMPT = 'GET_BY_POST_OBJECT_ATTEMPT'

//ROLES
export const GET_ROLES_ATTEMPT = 'GET_ROLES_ATTEMPT'

//ADD
export const ADD_OBJECT_ATTEMPT = 'ADD_OBJECT_ATTEMPT'
export const ADD_OBJECT_DATAPOOL_ATTEMPT = 'ADD_OBJECT_DATAPOOL_ATTEMPT'
export const ADD_OBJECT_TWO_STEP_ATTEMPT = 'ADD_OBJECT_TWO_STEP_ATTEMPT'

export const ADD_FILE_ATTEMPT = 'ADD_FILE_ATTEMPT'
export const ADD_FILE_DATAPOOL_ATTEMPT = 'ADD_FILE_DATAPOOL_ATTEMPT'


//LOCAL STORAGE
//QUERY
export const GET_QUERY_INITIALIZE_LS = 'GET_QUERY_INITIALIZE_LS'
export const GET_QUERY_DATA_ATTEMPT_LS = 'GET_QUERY_DATA_ATTEMPT_LS'
export const GET_MULTIPLE_QUERY_DATA_ATTEMPT_LS = 'GET_MULTIPLE_QUERY_DATA_ATTEMPT_LS'
export const GET_QUERY_OBJECT_RESULT_LS = 'GET_QUERY_OBJECT_RESULT_LS'
export const GET_QUERY_LIST_RESULT_LS = 'GET_QUERY_LIST_RESULT_LS'
export const GET_QUERY_ERROR_LS = 'GET_QUERY_ERROR_LS'

//ADD
export const ADD_OBJECT_ATTEMPT_LS = 'ADD_OBJECT_ATTEMPT_LS'

//MAPS
export const ADD_UPDATE_MAP_ATTEMPT_LS = 'ADD_UPDATE_MAP_ATTEMPT_LS'
export const GET_MAP_SPECIAL_ATTEMPT = 'GET_MAP_SPECIAL_ATTEMPT'
export const GET_MAP_WITH_KEY_SPECIAL_ATTEMPT = 'GET_MAP_WITH_KEY_SPECIAL_ATTEMPT'

//INITIALIZE
export const INITIALIZE_DATA = 'INITIALIZE_DATA'

export function InitializeDataAttempt_ACTION(Container){
    return({
        type: INITIALIZE_DATA,
        Container: Container
    })
}

export function GetRolesAttempt_ACTION(){
    return({
        type: GET_ROLES_ATTEMPT
    })
}

export function QueryInitialize_ACTION(){
    return({
        type: GET_QUERY_INITIALIZE,
        Container:{
            AddedSuccessfuly:false
        }
    })
}

export function GetListAttempt_ACTION(Container){
    return({
        type: GET_QUERY_DATA_ATTEMPT,
        Container: Container
    })
}

export function GetListDataPoolAttempt_ACTION(Container){
    return({
        type: GET_QUERY_DATA_DATA_POOL_ATTEMPT,
        Container: Container
    })
}

export function GetListObjectAttemptPost_ACTION(Container){
    return({
        type: GET_BY_POST_OBJECT_ATTEMPT,
        Container: Container
    })
}

export function GetMultipleListAttempt_ACTION(Containers){
    return({
        type: GET_MULTIPLE_QUERY_DATA_ATTEMPT,
        Containers: Containers
    })
}

export function GetMultipleListDataPoolAttempt_ACTION(Containers){
    return({
        type: GET_MULTIPLE_QUERY_DATA_DATA_POOL_ATTEMPT,
        Containers: Containers
    })
}


export function AddObjectAttempt_ACTION(Container){
    return({
        type: ADD_OBJECT_ATTEMPT,
        Container: Container
    })
}

export function AddObjectAttemptDataPool_ACTION(Container){
    return({
        type: ADD_OBJECT_DATAPOOL_ATTEMPT,
        Container: Container
    })
}


export function AddFileAttempt_ACTION(Container){
    return({
        type: ADD_FILE_ATTEMPT,
        Container: Container
    })
}

export function AddFileAttemptDataPool_ACTION(Container){
    return({
        type: ADD_FILE_DATAPOOL_ATTEMPT,
        Container: Container
    })
}


export function AddObjectTwoStepAttempt_ACTION(Container){
    return({
        type: ADD_OBJECT_TWO_STEP_ATTEMPT,
        Container: Container
    })
}


export function GetListAttempt_LS_ACTION(Container){
    return({
        type: GET_QUERY_DATA_ATTEMPT_LS,
        Container: Container
    })
}

export function AddObjectAttempt_LS_ACTION(Container){
    return({
        type: ADD_OBJECT_ATTEMPT_LS,
        Container: Container
    })
}


export function UpdateMap_LS_ACTION(Container){
    return({
        type: ADD_UPDATE_MAP_ATTEMPT_LS,
        Container: Container
    })
}

export function GeMap_SPECIAL_ACTION(Container){
    return({
        type: GET_MAP_SPECIAL_ATTEMPT,
        Container: Container
    })
}

export function GeMap_With_Key_SPECIAL_ACTION(Container){
    return({
        type: GET_MAP_WITH_KEY_SPECIAL_ATTEMPT,
        Container: Container
    })
}


